import React, { Component } from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import { getData, setData } from "../../../utils/util";
// import { updateAdminProfile } from '../../../actions/admin_action'
// core components

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Slide from "@material-ui/core/Slide";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardAvatar from "components/Card/CardAvatar.jsx";
import toastr from "toastr";

import axios from "../../../config/axios";

toastr.options = {
  closeButton: true
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const userDetails = {
  name: "Admin",
  email: "admin@gmail.com",
  
};

class UpdateProfile extends Component {
  constructor(props) {
    super(props);
    let adminData = getData("adminData");
    this.state = {
      adminData: adminData,
      name: null,
      email: null,
      profileImage:
    "http://www.ala-access.com/s/wp-content/uploads/2016/01/analyst-placeholder-avatar.png"
    };
  }

  componentDidMount() {
    this.setState({
      name: localStorage.getItem("name"),
      email: localStorage.getItem("email"),
      profileImage:localStorage.getItem("profileImage")
    });
  }

  updateAdminProfile = ({target}) => {
    const fd=new FormData();
    fd.append("file",target.files[0])
    let data = JSON.parse(localStorage.getItem("adminData"));
    let config = {};
    if (data) {
      config = {
        headers: { Authorization: `Bearer ${data.authToken}` , "Content-Type": "multipart/form-data",},
        
      };
    }
    console.log("888888888",fd , target.files[0])

    if (!this.state.name) {
      toastr.error("Please enter the name");
    } else {
      const id = localStorage.getItem("id");
      let obj = {
        name: this.state.name,
        //profileImage:fd
      };
      axios
        .patch(`admin/users/${id}/update-profile`, fd, obj)
        .then(res => {
          toastr.success(res.data.message);
          localStorage.setItem("name", obj.name);
          this.setState({ name: localStorage.getItem("name") });
        })
        .catch(err => {
          toastr.error(err.response.data.message);
          this.setState({ name: localStorage.getItem("name") });
        });
      // this.props.updateAdminProfile(obj, () => {
      //   let admin = getData("adminData");
      //   admin["name"] = this.state.name;
      //   setData("adminData", admin);
      //   this.props.handleClose();
      // });
    }
  };

  // handleChange=({target})=>{
  //   const fd=new FormData();
  //   this.setState({profileImage:fd.append("file",target.files[0])});

  // }

  render() {
    const { show, handleClose, openResetPassword } = this.props;
    // const { adminData } = this.state;
    return (
      <div>
        <Dialog
          className="update-profile-dialog-box"
          open={show}
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          TransitionComponent={Transition}
          keepMounted
          PaperProps={{
            style: {
              display: "inline-table",
              position: "relative",
              width: "35%"
            }
          }}
        >
          <Card profile style={{ display: "inline" }}>
            {/* <CardAvatar profile>
              
                <img src={this.state.profileImage} alt="..." onClick={(e)=>{
                  e.preventDefault(),
                  this.inputRef.click()
                }
                }/>
                <input ref={(inputRef)=>{
                  this.inputRef=inputRef
                }}
                type="file"
                accept="image/*"
                style={{display:"none"}}
                onChange={this.updateAdminProfile}/>
              
            </CardAvatar> */}
            <CardBody profile>
              <DialogContent>
                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  label="Name"
                  type="name"
                  fullWidth
                  value={this.state.name}
                  onChange={e => {
                    this.setState({
                      name: e.target.value
                    });
                  }}
                />
                <TextField
                  margin="dense"
                  id="email"
                  label="Email"
                  type="email"
                  fullWidth
                  disabled={true}
                  value={this.state.email}
                />
              </DialogContent>
            </CardBody>
          </Card>
          <DialogActions style={{ textAlign: "center", display: "block" }}>
            <Button color="primary" onClick={handleClose}>
              Close
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={this.updateAdminProfile}
            >
              Update
            </Button>
          </DialogActions>
          <div className={"reset-password"}>
            <a onClick={openResetPassword} style={{cursor:"pointer"}}>Reset Password</a>
          </div>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    // loginError: state.admin.loginError
  };
};

const mapDispatchToProps = dispatch => {
  return {
    // updateAdminProfile: (obj,callback)=> dispatch(updateAdminProfile(obj,callback))
  };
};

const UpdateProfileComponent = withStyles(extendedTablesStyle)(UpdateProfile);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdateProfileComponent);



// WEBPACK FOOTER //
// ./src/components/Common/FevoModels/UpdateProfile.jsx